/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PatchedDomainName
 */
export interface PatchedDomainName {
    /**
     * 
     * @type {number}
     * @memberof PatchedDomainName
     */
    readonly id?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedDomainName
     */
    name?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedDomainName
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedDomainName
     */
    readonly updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof PatchedDomainName
     */
    readonly leaksCount?: string;
}

/**
 * Check if a given object implements the PatchedDomainName interface.
 */
export function instanceOfPatchedDomainName(value: object): value is PatchedDomainName {
    return true;
}

export function PatchedDomainNameFromJSON(json: any): PatchedDomainName {
    return PatchedDomainNameFromJSONTyped(json, false);
}

export function PatchedDomainNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedDomainName {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
        'leaksCount': json['leaks_count'] == null ? undefined : json['leaks_count'],
    };
}

  export function PatchedDomainNameToJSON(json: any): PatchedDomainName {
      return PatchedDomainNameToJSONTyped(json, false);
  }

  export function PatchedDomainNameToJSONTyped(value?: Omit<PatchedDomainName, 'id'|'created_at'|'updated_at'|'leaks_count'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

